import { Injectable } from "@angular/core";
import { StaffRequirementsService } from "lib-klab-sdks";
import { map, Observable } from "rxjs";
import { RequirementsPort } from "../../../app/ports/requirement/requirements.port";
import {
  Requirement, RequirementListRequest, RequirementPage, RequirementRecord,
  RequirementRequest, RequirementStatuses, RequirementSummary, RequirementSummaryRequest,
} from "../../../domain/models/requirement/requirement.model";
import { mapRequirement, mapRequirementListRequest, mapRequirementPage, mapRequirementRecord, mapRequirementRequest, mapRequirementStatuses, mapRequirementSummary } from "../../mappers/requirement/requirement.mapper";

@Injectable({ providedIn: "root" })
export class RequirementsPortAdapter implements RequirementsPort {
  constructor(private readonly api: StaffRequirementsService) {}

  list(request: RequirementListRequest): Observable<RequirementPage> {
    return this.api.list(mapRequirementListRequest(request)).pipe(map(({ data }) => mapRequirementPage(data)));
  }

  listMine(request: Omit<RequirementListRequest, "requesterUserId"> = {}): Observable<RequirementPage> {
    return this.api.listMine(mapRequirementListRequest(request)).pipe(map(({ data }) => mapRequirementPage(data)));
  }

  get(id: number): Observable<Requirement> {
    return this.api.get(id).pipe(map(({ data }) => mapRequirement(data)));
  }

  create(request: RequirementRequest): Observable<RequirementRecord> {
    return this.api.create(mapRequirementRequest(request)).pipe(map(({ data }) => mapRequirementRecord(data)));
  }

  update(id: number, request: RequirementRequest): Observable<RequirementRecord> {
    return this.api.update(id, mapRequirementRequest(request)).pipe(map(({ data }) => mapRequirementRecord(data)));
  }

  delete(id: number): Observable<void> {
    return this.api.delete(id).pipe(map(() => undefined));
  }

  listStatuses(): Observable<RequirementStatuses> {
    return this.api.listStatuses().pipe(map(({ data }) => mapRequirementStatuses(data)));
  }

  summary(request: RequirementSummaryRequest = {}): Observable<RequirementSummary> {
    return this.api.summary(request).pipe(map(({ data }) => mapRequirementSummary(data)));
  }

  mineSummary(month?: string): Observable<RequirementSummary> {
    return this.api.mineSummary(month).pipe(map(({ data }) => mapRequirementSummary(data)));
  }
}
